import { getBadgeClass } from "./badge.styles";
import type { BadgeProps } from "./badge.types";

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={getBadgeClass({ variant, className, size })} {...props} />;
}
